import { useEffect } from "react";
import useAuthAxios from "../../hooks/useAuthAxios";
import useAxios from "../../hooks/useAxios";
import Loader from "../../hocs/Loader";
import ChatIcon from "../../utils/ChatIcon";

function AdminDashboard() {
  const app_url = "dashboard/admin";
  const axios = useAuthAxios();
  const [response, error, loading, axiosFetch] = useAxios();

  const getData = () => {
    axiosFetch({
      axiosInstance: axios,
      method: "GET",
      url: `${app_url}`,
    });
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, []);
  return (
    <>
      {loading && <Loader />}
      {error && (
        <p className="text-base font-normal text-gray-600">
          No data to display
        </p>
      )}
      <section className="px-2 sm:px-2 lg:px-2 w-full">
        <div className="flex flex-wrap gap-4">
          <div
            className="
            rounded bg-white
            overflow-hidden shadow-md
            p-4
            flex-auto w-48"
          >
            <div className="flex">
              <div
                className="flex-none w-20 relative 
              bg-green-500 rounded text-white"
              >
                <ChatIcon size={`w-20 h-20`} />
              </div>
              <div className="flex-auto pl-6">
                <div className="flex-wrap">
                  <p
                    className="flex-none w-full 
                    text-lg text-gray-500 pb-4"
                  >
                    SMS Balance
                  </p>
                  <p
                    className="flex-none w-full 
                    text-3xl text-gray-800 
                    font-semibold"
                  >
                    {response?.sms_balance}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default AdminDashboard;
